import { render } from "./InfrastructureTabView.vue?vue&type=template&id=24b72222"
import script from "./InfrastructureTabView.vue?vue&type=script&lang=js"
export * from "./InfrastructureTabView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__